export default "__VITE_ASSET__CmhCgDJp__"